import { useMemo } from 'react';
import { Tag } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import type { TriggerResponseDto } from '@evimo/client/models';
import { useTranslation } from 'react-i18next';
import { formatTriggerConditionsSummary } from '~/app/components/maintenance/tasks-triggers/utils';

export function useTriggersTabColumns(): ColumnsType<TriggerResponseDto> {
  const { t } = useTranslation('maintenance');

  return useMemo(
    () => [
      {
        title: t('triggers.basis'),
        dataIndex: 'basis',
        key: 'basis',
        render: (val: string) => <Tag>{t(`triggerBasis.${val}`)}</Tag>,
      },
      {
        title: t('triggers.conditions'),
        dataIndex: 'conditions',
        key: 'conditions',
        render: (_: unknown, record: TriggerResponseDto) =>
          formatTriggerConditionsSummary(record.conditions),
      },
      {
        title: t('common.createdAt'),
        dataIndex: 'createdAt',
        key: 'createdAt',
        render: (val: string) => new Date(val).toLocaleDateString(),
      },
    ],
    [t],
  );
}
